import {
  EventModelingModule,
  createEventModelingServices
} from "./chunk-N66VUXT2.mjs";
import "./chunk-NNHCCRGN.mjs";
export {
  EventModelingModule,
  createEventModelingServices
};
